import loaders from './0001/loaders'

function cardItemImageLoader(blobData, context) {
  if (Object.prototype.hasOwnProperty.call(blobData, 'cardItems') &&
    (blobData.widgetType === 'carousel' || blobData.widgetType === 'grid') &&
    blobData.cardItems.constructor === Array) {
    let presets = []
    if (blobData.widgetType === 'carousel') {
      // Define Presets for Carousel Widget based cards
      presets = [
        'carousel-image',
        'carousel-image__lowres'
        // 'carousel-image-phone-portrait',
        // 'carousel-image-phone-landscape',
        // 'carousel-image-tablet',
        // 'carousel-image-2k',
        // 'carousel-image-4k',
        // 'carousel-image-fhd'
      ]
    }
    else if (blobData.widgetType === 'grid') {
      // Define Presets for Grid Widget based cards
      presets = [
        'grid-image-full',
        'grid-image-one-half',
        'grid-image-one-third',
        'grid-image-two-third',
        'grid-image-full__lowres',
        'grid-image-one-half__lowres',
        'grid-image-one-third__lowres',
        'grid-image-two-third__lowres',
        ''
      ]
    }

    let imageLoaders = blobData.cardItems
      .filter(card => card.opmode === 'filestore' && (card.cardType === 'photo' || card.cardType === 'icon'))

    imageLoaders = imageLoaders.reduce((acc, card) => {
      acc = acc.concat(
        presets.map(preset => ({
          filestorename: context.filestore || 'website',
          filepath: card.fileStore.filepath,
          preset: preset
        }))
      )
      return acc
    }, [])
      .filter(img => img.filepath)
      .reduce((acc, img) => ({ // This reduce should remove all duplicate files from the loader
        ...acc,
        [`${img.filestorename}--${img.filepath}--${img.preset}`]: img
      }), {})

    imageLoaders = Object.values(imageLoaders)

    if (!imageLoaders.length) {
      return
    }

    // This ImageLoaders is an Object that will collect a number of files and then process the
    // presigned url load together - reducing the number of fusws requests made
    if (context.imageLoader !== undefined) {
      context.imageLoader.add(imageLoaders)
      return Promise.resolve()
    }
    else {
      return context.dispatch('filestore/getFileURLBulk', { files: imageLoaders, filestorename: context.filestore || 'website' })
        .then(_files => {
          // Object.values(_files).forEach(f => applogger.debug(`Blob File prefetched: ${f}`))
        })
    }
  }
}

function contentListLoader(blobData, context) {
  if (blobData && Object.prototype.hasOwnProperty.call(blobData, 'widgetType') && blobData.widgetType === 'content-list') {
    let listType = blobData.widgetSettings.listType
    const listTypeParts = listType.split(('-'))
    if (listTypeParts.length === 2 && (listTypeParts[0] === 'latest' || listTypeParts[0] === 'featured')) {
      // Not using the updated blob structure. Caress the old structure.
      listType = listTypeParts[1]
    }

    switch (listType) {
    case 'news':
      return loaders.loadNews(context, {
        key: 'content-list-news',
        latest: blobData.widgetSettings.sortType === 'latest' || listTypeParts[0] === 'latest',
        featured: blobData.widgetSettings.isFeatured || listTypeParts[0] === 'featured',
        limit: blobData.widgetSettings.maxItems,
        filestore: context.fileStore || 'website',
        articleCategory: blobData.widgetSettings.articleCategory
      })
        // We return a 'undefined' here to indicate to the blob processor that we are not
        // modifying the blob contents and to pass original blob to the next processor
        .then(_ => undefined)

    case 'products':
      return loaders.loadProducts(context, {
        key: 'content-list-products',
        latest: blobData.widgetSettings.sortType === 'latest' || listTypeParts[0] === 'latest',
        featured: blobData.widgetSettings.isFeatured || listTypeParts[0] === 'featured',
        limit: blobData.widgetSettings.maxItems,
        filestore: context.fileStore || 'website'
      })
        // We return a 'undefined' here to indicate to the blob processor that we are not
        // modifying the blob contents and to pass original blob to the next processor
        .then(_ => undefined)
    }
  }
}

export default {
  cardItemImageLoader,
  contentListLoader
}
